import type { TaskListItem } from '@/hooks/useTasks';

export function mergeAssignedGeneralTasks(
  dayTasks: TaskListItem[],
  assignedGeneralTasks: TaskListItem[],
  viewUserId: string | undefined,
): TaskListItem[] {
  if (!viewUserId) return dayTasks;
  const existing = new Set(dayTasks.map((t) => t.id));
  const extras = assignedGeneralTasks.filter(
    (t) => t.assignedTo?.id === viewUserId && !existing.has(t.id),
  );
  return extras.length === 0 ? dayTasks : [...dayTasks, ...extras];
}
